// API root without the /llm suffix, for endpoints served outside /llm.
const apiBaseUrl = (
  import.meta.env.VITE_API_BASE_URL ||
  import.meta.env.VITE_SAAS_ENDPOINT ||
  'https://api.staging.qanda-assist.com'
).replace(/\/+$/, '');

/** Production builds (`vite build --mode prod`) never show test or demo entry points. */
const isProductionBuild = import.meta.env.MODE === 'prod';

export const AppConfig = {
  isProductionBuild,
  /** Application release label on the sign-in page (not a file version). */
  release: __APP_RELEASE__,
  links: {
    company: import.meta.env.VITE_LINK_COMPANY || 'https://www.rozetta.jp/',
    terms:
      import.meta.env.VITE_LINK_TERMS ||
      'https://www.rozetta.jp/rakuyaku_terms.pdf',
    privacy:
      import.meta.env.VITE_LINK_PRIVACY || 'https://www.rozetta.jp/privacy/',
    /**
     * Header Help: the bilingual manual that scripts/manual/build.mjs builds
     * into /manual/ (VITE_MANUAL_URL once it has its own domain); `{lang}`
     * becomes ja or en.
     */
    manual: import.meta.env.VITE_MANUAL_URL || '/manual/?lang={lang}',
  },
  devLogin: {
    enabled: !isProductionBuild && import.meta.env.VITE_DEV_LOGIN === 'true',
    endpoint: `${apiBaseUrl}/auth/dev-login`,
  },
  axios: {
    saas_endpoint:
      import.meta.env.VITE_SAAS_ENDPOINT ||
      'https://api.staging.qanda-assist.com',
    llm_endpoint:
      import.meta.env.VITE_LLM_ENDPOINT ||
      'https://api.staging.qanda-assist.com/llm',
    /**
     * Where run event streams are read (GET /chat/runs/{id}/events); the
     * API by default. An open stream holds a PHP worker for up to 10
     * minutes, so a server that runs one request at a time (the local
     * stack) serves streams from a second process.
     */
    llm_stream_endpoint:
      import.meta.env.VITE_LLM_STREAM_ENDPOINT ||
      import.meta.env.VITE_LLM_ENDPOINT ||
      'https://api.staging.qanda-assist.com/llm',
    timeout: 600000,
  },
  auth0: {
    domain: import.meta.env.VITE_AUTH0_DOMAIN || 'prod-qa-assist.jp.auth0.com',
    clientId:
      import.meta.env.VITE_AUTH0_CLIENT_ID ||
      'KFII3oRwNQ7iZ4QQRRE8eDPtWzLMIeaZ',
    authorizationParams: {
      redirect_uri:
        import.meta.env.VITE_AUTH0_REDIRECT_URI ||
        'https://staging.qanda-assist.com/',
      audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
    },
  },
};
